import { TWaterFallModel } from "../../../../components/HighChart_Waterfall/HighchartWaterfall";
import { TDiversCartWaterfallModel } from "../types/DiversificacionCarteraTypes";

type TFormatDataWaterfallProps = {
    dataWaterfall: TDiversCartWaterfallModel[];};

export const FormatDataWaterfall = ( { dataWaterfall } : TFormatDataWaterfallProps): TWaterFallModel[] => {
    let resultWaterFall = [] as TWaterFallModel[];

    dataWaterfall.forEach((daraW: TDiversCartWaterfallModel) => {
        if (daraW.tipoActivo !== 'Volatilidad con Correlación 1' && daraW.tipoActivo !== 'Volatilidad con Correlación Real') {
            resultWaterFall.push({
                name: daraW.tipoActivo,
                y: daraW.valor
            })
        }
    })

    const first = dataWaterfall.find(daraw => daraw.tipoActivo === 'Volatilidad con Correlación 1');
    const last = dataWaterfall.find(daraw => daraw.tipoActivo === 'Volatilidad con Correlación Real');

    if (first && last) {
        resultWaterFall.push({
            name: last?.tipoActivo,
            y: -1 * last?.valor,
            color: 'transparent',
            borderColor: 'transparent',
            enableMouseTracking: false,
            showInLegend: false,
            dataLabels: { enabled: false }
        }, {
            name: last?.tipoActivo,
            y: last?.valor
        })
        resultWaterFall.unshift({
            name: first?.tipoActivo,
            y: first?.valor
        })
    }

    return resultWaterFall;
};